import {toggleHidden} from "../lib/domFunctions";
import {fetchJson} from "../lib/fetch";
import {AppConfig} from "../AppConfig";
import {coalesce} from "../lib/coalesce";
import {ProcessInputFieldChange, ProcessInputFieldSearch, ProcessInputModalSearch, ProcessInputModalSearchOptions} from "./ProcessInputModalSearch";

export class ProcessInputField {
	private readonly fireChange: ProcessInputFieldChange;
	private readonly request: ProcessInputFieldSearch;
	private readonly valueField: HTMLInputElement;
	private readonly textField: HTMLInputElement;

	constructor(params: { valueField: HTMLInputElement, textField: HTMLInputElement, change: ProcessInputFieldChange, request?: ProcessInputFieldSearch }) {
		this.valueField = params.valueField
		this.textField = params.textField
		this.request = coalesce(params.request, (search, limit) => fetchJson(`/processes/listPage?search=${encodeURIComponent(search)}&offset=0&limit=${limit}`))
		this.fireChange = (item) => {
			this.toggleProcessButtons()
			return params.change(item);
		}

		const group = this.uiGroup
		if (group) {
			group.querySelectorAll('[data-bind="clearProcess"]').forEach(node => node.addEventListener('click', this.clear.bind(this)))
			group.querySelectorAll('[data-bind="searchProcess"]').forEach(node => node.addEventListener('click', this.search.bind(this)))
		}

		this.textField.addEventListener('click', e => {
			if (this.textField.disabled) return;

			if (this.value == null) {
				this.search()
				e.preventDefault();
			}
		})
	}

	get value(): number | null {
		const valueParsed = parseInt(this.valueField.value);
		return Number.isFinite(valueParsed) ? valueParsed : null;
	}

	get valueText(): string {
		return this.textField.value.trim()
	}

	private get uiGroup() {
		return this.textField.closest('.input-group');
	}

	private toggleProcessButtons() {
		const selected = this.value != null && this.value > 0
		const group = this.uiGroup
		if (!group) return;

		group.querySelectorAll('[data-bind="clearProcess"]').forEach(node => toggleHidden(node, !selected))
		group.querySelectorAll('a[data-bind="openProcess"]').forEach(node => {
			toggleHidden(node, !selected)
			node.setAttribute('href', `${AppConfig.CP}/processes/${this.value}/edit`)
		})
	}

	clear() {
		this.valueField.value = '';
		this.textField.value = '';
		this.textField.setAttribute('title', '')
		this.fireChange(null)
	}

	search() {
		const options: ProcessInputModalSearchOptions = {
			search: this.request
		}
		new ProcessInputModalSearch((item) => {
			if (item == null) return
			if (item.id.toString() === this.valueField.value) return

			this.set(item.id, item.code, item.name)
			return this.fireChange(item)
		}, options);
	}

	set(id: number, code: string, name: string) {
		this.valueField.value = id.toString()
		this.textField.value = `${code} ${name}`
		this.textField.setAttribute('title', this.textField.value)
		this.toggleProcessButtons()
	}

	enable(enabled: boolean) {
		const group = this.uiGroup

		function setDisabled(element: Element, disabled: boolean) {
			if (disabled) {
				element.setAttribute('disabled', 'disabled')
			} else {
				element.removeAttribute('disabled')
			}
		}

		setDisabled(this.valueField, !enabled)
		setDisabled(this.textField, !enabled)
		if (group) {
			group.querySelectorAll('[data-bind="clearProcess"]').forEach(node => setDisabled(node, !enabled))
			group.querySelectorAll('[data-bind="searchProcess"]').forEach(node => setDisabled(node, !enabled))
		}
	}
}
